/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { Scene7Service, TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'clp-deal-block',
	templateUrl: './deal-block.component.html',
	styleUrl: './deal-block.component.scss',
	standalone: false
})
export class DealBlockComponent implements OnInit {
	@Input() data: any;

	@Input() drawer: string;

	createDealTag = TaggingService.createDealDrawerTag;

	constructor(private scene7UrlService: Scene7Service) {}

	scene7service(imageName: string) {
		return this.scene7UrlService.scene7Url(imageName);
	}

	ngOnInit() {
		if (this.data && this.data.dealType) {
			this.data.dealTypeClass = this.data.dealType.replace(/\s/g, '');
		}
	}
}
